<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
      v-if="!loadingData"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card
          max-width="800"
          elevation="0"
          rounded="xxl"
          color="background"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('responseOwnerRightsActivityTitle', { user: user}) }}
          </v-card-title>
          <div> 
            <v-row
              no-gutters
              align="center"
              class="fill-height"
            >
              <v-col
                cols="12"
                class="mx-auto pa-0"
                align="center"
              >
                <div v-if="request.accepted == null" class="font-weight-bold mx-auto pa-4">
                  <span>{{ $t('responseOwnerRightsText') }}</span>
                </div>
                <div v-if="request.accepted == true" class="font-weight-bold mx-auto pa-4">
                  <span v-if="responder == null">
                    {{ $t('responseOwnerRightsAccepted', { date: format_date(request.respondedAt) }) }}
                  </span>
                  <span v-else>
                    {{ $t('responseOwnerRightsAcceptedBy', { responder: responder, date: format_date(request.respondedAt) }) }}
                  </span>
                  
                </div> 
                <div v-if="request.accepted == false" class="font-weight-bold mx-auto pa-4">
                  <span v-if="responder == null">
                    {{ $t('responseOwnerRightsRejected', { date: format_date(request.respondedAt) }) }}
                  </span>
                  <span v-else>
                    {{ $t('responseOwnerRightsRejectedBy', { responder: responder, date: format_date(request.respondedAt) }) }}

                  </span>
                </div>              
              </v-col>
            </v-row>
          </div>
        </v-card>
        <v-row>
          <v-col align="center">
            <v-card-actions v-if="request.accepted == null" class="justify-center">
              <v-btn
                ref="reject"
                data-testid="reject-button"
                color="error"
                min-width="100"
                elevation="0"
                class="rounded-xxl text-none px-4 mb-2 mb-md-0 white--text"
                @click="acceptRequest(false)"
              >
                {{ $t('reject') }}
              </v-btn>
              <v-btn
                ref="accept"
                data-testid="accept-button"
                color="accent"
                min-width="100"
                elevation="0"
                class="rounded-xxl text-none px-4 mb-2 mb-md-0 white--text"
                @click="acceptRequest(true)"
              >
                {{ $t('accept') }}
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-col>
    </v-row>          
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import AlertMessages  from '../../components/AlertMessages'
import { getRequestToBecomeOwner, updateRequestToBecomeOwner } from '../../api/activityApi'
import moment from 'moment'

export default {
    components: {
        AlertMessages
    },
    data () {
        return {
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertValue:false,
            valid: true,
            activityId: this.$route.params.id,
            requestId: this.$route.params.requestId,
            cancelLink: '/activity/'+this.$route.params.id,
            loadingData: false,
            requesterId: null,
            responder: null,
            user: null,
            userId: window.$cookies.get('id'),
            request: {}
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.path != null && from.path != '/redirect' && from.path != '/'){
            next(vm => {
                vm.cancelLink = from.path
            });
        }else { 
            next();
        }
    },

    async created(){
        this.loadingData = true
        await this.getRequestToBecomeOwner()
        this.loadingData = false
    },
    methods: {
      async getRequestToBecomeOwner(){
        try {
          const response = await getRequestToBecomeOwner(this.requestId)
          if(response.status == 200) {
            this.request = response.data.data.attributes
            this.requesterId = response.data.data.relationships.user.data.id
            this.responder = response.data.data.meta.responder
            this.user = response.data.data.meta.user
          }            
        } catch (e) {
          if(e.response){
              if (e.response.status == 403){
                this.$router.push({name: 'PageAccessDenied'})
              } else if(e.response.status == 404) {
                this.$router.push({name: 'PageNotFound'})
              } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
              }
          }            
        }
      },
      async acceptRequest(answer){
         let data = {
          data: {
            type: "requests-owner-rights",
            id: this.requestId.toString(),
            attributes: {
              accepted: answer
            },
            relationships: {
              requestable: {
                data: {
                  type: "activities",
                  id: this.$route.params.id
                }
              },
              user: {
                data: {
                  type: "users",
                  id: this.requesterId.toString()
                }
              },
              responder: {
                data: {
                  type: "users",
                  id: this.userId
                }
              }
            }
          }
        };

        try {
          const response = await updateRequestToBecomeOwner(this.requestId, data)
          if(response.status == 200) {
            this.alertValue = true
            this.alertType = 'success'
            this.alertMsg =  answer ? i18n.t('requestAcceptedSuccess') : i18n.t('requestRejectedSuccess')
            await this.getRequestToBecomeOwner()
          }            
        } catch (e) {
          if(e.response){
              if (e.response.status == 403){
                this.$router.push({name: 'PageAccessDenied'})
              } else if(e.response.status == 404) {
                this.$router.push({name: 'PageNotFound'})
              } else if(e.response.status == 400) {
                for(let i = 0; i < e.response.data.errors.length; i++){
                  if(e.response.data.errors[i].detail == 'User is not booster in the space!'){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg = i18n.t('responseOwnerRightsNotBoosterError')
                  }else if(e.response.data.errors[i].detail == 'User is already a booster!'){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg = i18n.t('responseOwnerRightsAlreadyBoosterError')
                  }else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg = i18n.t('serverError')
                  }
                }
              } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
              }
          }            
        }
      },
      format_date(value){
        if (value) {
          return moment(String(value)).format('DD MMM YYYY')
        }
      },
    }
}

</script>